import React, { createContext, JSX, useContext } from 'react';
import { Centrifuge } from 'centrifuge';

import { useCentrifuge } from '@/shared/hooks/useCentrifuge';

type CentrifugeContextType = {
    centrifuge: Centrifuge | null;
    isReady: boolean;
    subscribeToChannel: (channel: string) => void;
    subscribedChannels: Set<string>;
    unsubscribeFromChannel: (channel: string) => void;
    unsubscribeFromAllChannels: () => void;
};

type CentrifugeProviderProps = {
    children: JSX.Element;
};

export const CentrifugeContext = createContext<CentrifugeContextType>({
    centrifuge: null,
    isReady: false,
    subscribedChannels: new Set<string>(),
    subscribeToChannel: () => {},
    unsubscribeFromChannel: () => {},
    unsubscribeFromAllChannels: () => {},
});

export const CentrifugeProvider = ({ children }: CentrifugeProviderProps) => {
    const {
        centrifuge,
        isReady,
        subscribeToChannel,
        subscribedChannels,
        unsubscribeFromChannel,
        unsubscribeFromAllChannels,
    } = useCentrifuge();

    return (
        <CentrifugeContext.Provider
            value={{
                centrifuge,
                isReady,
                subscribeToChannel,
                unsubscribeFromChannel,
                subscribedChannels,
                unsubscribeFromAllChannels,
            }}
        >
            {children}
        </CentrifugeContext.Provider>
    );
};

export const useCentrifugeContext = () => useContext(CentrifugeContext);
